var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 9.60002V8.40002C18 5.09162 15.3084 2.40002 12 2.40002C8.69158 2.40002 5.99998 5.09162 5.99998 8.40002V9.60002C4.67398 9.60002 3.59998 10.674 3.59998 12V19.2C3.59998 20.526 4.67398 21.6 5.99998 21.6H18C19.326 21.6 20.4 20.526 20.4 19.2V12C20.4 10.674 19.326 9.60002 18 9.60002ZM13.2 16.8C13.2 17.4624 12.6624 18 12 18C11.3376 18 10.8 17.4624 10.8 16.8V14.4C10.8 13.7376 11.3376 13.2 12 13.2C12.6624 13.2 13.2 13.7376 13.2 14.4V16.8ZM15.6 9.60002H8.39998V8.40002C8.39998 6.41522 10.0152 4.80002 12 4.80002C13.9848 4.80002 15.6 6.41522 15.6 8.40002V9.60002Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLocked);
export default __webpack_public_path__ + "static/media/lock-locked.85b9d94a54fe22534bb6d014d33a2095.svg";
export { ForwardRef as ReactComponent };